import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './CheckboxInputList.css';
import CheckboxInput from '../checkbox-input/CheckboxInput';
import InputError from '../../../errors/InputError';

export default class CheckboxInputList extends Component {
  getValue = () => {
    let values = [];
    let errors = [];

    this.props.checkboxProps.forEach((cbProp) => {
      try {
        let isChecked = this[cbProp.id].getValue();
        if (isChecked) {
          values.push(cbProp.id);
        }
      }
      catch (error) {
        errors.push(error.message);
      }
    });

    if (!values.length) {
      errors.unshift(this.props.legend + " is Required")
    }

    if (errors.length) {
      throw new InputError(errors.join(", "), values);
    }
    else {
      return values;
    }
  }

  render() {
    const requiredFieldIndicator = (this.props.required && this.props.isEditable)
      ? <abbr title="This field is required">*</abbr>
      : null;

    let legend = (this.props.legend || this.props.required)
      ? <legend>{requiredFieldIndicator}{this.props.legend}</legend>
      : null;

    let verticalSpacingClass = this.props.verticalSpacing === "compact" ? "field--compact" : "field";

    let errorMessage = (this.props.errorMessage)
      ? <span className="error-message">
          {this.props.errorMessage}
        </span>
      : null;

    const checkboxes = this.props.checkboxProps.map((cbProp, index) => {
      let isCbChecked = ((
          this.props.selectedIds &&
          this.props.selectedIds.indexOf(cbProp.id) !== -1
        ) ||
        cbProp.checked
      );

      return (
        <CheckboxInput
          checked={isCbChecked}
          className={cbProp.className}
          id={cbProp.id}
          key={cbProp.id}
          label={cbProp.label}
          name={this.props.groupName}
          onChange={this.props.onChange}
          ref={instance => { this[cbProp.id] = instance; }}
          value={cbProp.value}
        />
      );
    });

    let checkedCsv = (this.props.selectedIds) ?
      this.props.selectedIds.map((selected) => {
        let propIndex = this.props.checkboxProps.findIndex((cbProp) => cbProp.id === selected);

        if (propIndex !== -1) {
          return this.props.checkboxProps[propIndex].label;
        }
        return null;
      }).join(", ") :
      this.props.checkboxProps
        .filter((cbProp) => (cbProp.checked))
        .map((cbProp) => (cbProp.label))
        .join(", ");

    let checkboxListContent = (this.props.isEditable) ?
      <span id={this.props.id}>
        <fieldset disabled={this.props.disabled} className="field__group">
          {legend}
          {checkboxes}
        </fieldset>
        {errorMessage}
      </span> :
      <span>
        {legend}
        <div className="read-only">
          {checkedCsv}
        </div>
      </span>;

    return (
      <div className={verticalSpacingClass}>
        {checkboxListContent}
      </div>
    );
  }
}

CheckboxInputList.defaultProps = {
  isEditable: true
};

CheckboxInputList.propTypes = {
  className: PropTypes.string,
  checkboxProps: PropTypes.arrayOf(PropTypes.shape({
    checked: PropTypes.bool,
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired
  })).isRequired,
  disabled: PropTypes.bool,
  errorMessage: PropTypes.string,
  groupName: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  isEditable: PropTypes.bool,
  legend: PropTypes.string,
  onChange: PropTypes.func,
  required: PropTypes.bool,
  selectedIds: PropTypes.arrayOf(PropTypes.string),
  verticalSpacing: PropTypes.string
}



// WEBPACK FOOTER //
// ./src/shared/components/presentation/checkbox-input-list/CheckboxInputList.js